import axios from "axios";
import { toast } from "react-toastify";
import companyAuthHeader from "./companyAuthHeader";

const baseUrl = `${process.env.REACT_APP_BASE_URL}/company-admin/api-tokens`;

export const getCompanyApiTokens = () =>
  axios
    .get(baseUrl, { headers: companyAuthHeader() })
    .then((res) => res.data.data);

export const createCompanyApiToken = (data) =>
  axios
    .post(baseUrl, data, { headers: companyAuthHeader() })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((error) => {
      if (error?.response?.data?.msg) toast.error(error.response.data.msg);
      return Promise.reject(error);
    });

export const revokeCompanyApiToken = (id) =>
  axios
    .delete(`${baseUrl}/${id}`, { headers: companyAuthHeader() })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((error) => {
      if (error?.response?.data?.msg) toast.error(error.response.data.msg);
      return Promise.reject(error);
    });
